var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import EnvironmentService from "../EnvironmentService.js";
class ConsoleLogProvider {
  warn(event) {
    console.warn(event.message, event.properties);
  }
  info(event) {
    console.info(event.message, event.properties);
  }
  log(event) {
    console.log(event.message, event.properties);
  }
  error(event) {
    console.error(event.message, event.properties);
  }
  exception(error) {
    const _a = error.error, { message, name, stack } = _a, otherParams = __objRest(_a, ["message", "name", "stack"]);
    const props = __spreadValues(__spreadValues({ name, stack }, otherParams), error.properties);
    if (console.exception) {
      console.exception(message, props);
    } else {
      this.error({ message, properties: props });
    }
  }
  pageView(pageView) {
    if (EnvironmentService.isDebug) {
      console.info(`PageView ${pageView.name}`, pageView);
    }
  }
  trackEvent(event) {
    console.info(`Event ${event.name}`, event);
  }
  trackMetric(metric) {
    console.info(`Metric ${metric.name}`, metric);
  }
  trackDependency(dependency) {
    console.info(`Dependency ${dependency.method} ${dependency.method}`, dependency);
  }
}
export {
  ConsoleLogProvider
};
//# sourceMappingURL=ConsoleLogProvider.js.map
